import request from "@/utils/request"

// 登录
export const login = function(params) {
  return request('post', '/api/auth/login', params)
}

// 扫码登录
export const scanLogin = function() {
  return request('post', '/api/auth/login/scan', params)
}

// 发送验证码
export const fetchVerify = function(params = {}) {
  return request('post', '/api/auth/getSmsVerifyCode', params)
}

// 手机号验证码登录
export const loginByVerify = function(params = {}) {
  return request('post', '/api/auth/login/mobile', params)
}

// 注销用户
export const cancelAccount = function() {
  return request('post', '/api/user/logoff')
}